"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/core-js/modules/es.array.iterator.js");

require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/core-js/modules/es.promise.js");

require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/core-js/modules/es.object.assign.js");

require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/core-js/modules/es.promise.finally.js");

var _vue = _interopRequireDefault(require("vue"));

require("normalize.css/normalize.css");

var _elementUi = _interopRequireDefault(require("element-ui"));

require("element-ui/lib/theme-chalk/index.css");

var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));

require("@/styles/index.scss");

var _Permission = _interopRequireDefault(require("./components/Permission"));

var _App = _interopRequireDefault(require("./App"));

var _store = _interopRequireDefault(require("./store"));

var _router = _interopRequireDefault(require("./router"));

var _index3 = _interopRequireDefault(require("../components/search-table-pagination/index"));

require("@/icons");

require("@/permission");

// A modern alternative to CSS resets
// import '@/styles/theme/index.css'  // 样式皮肤颜色控制
// lang i18n
// import Reward from '@/components/Reward'
// global css
// 权限指令
// 表单表格分页器封装组件（大部分列表界面使用）
// icon
// permission control
// if (process.env.NODE_ENV === 'production') {
// const { mockXHR } = require('@/mock')
// mockXHR()
// }
_vue.default.use(_elementUi.default, {
  locale: _zhCN.default,
  size: 'medium'
}); // 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)


_vue.default.use(_Permission.default);

_vue.default.use(_index3.default);

_vue.default.config.productionTip = false; // console.log(Reward)
// Vue.component(Reward.name, Reward)

new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  render: function render(h) {
    return h(_App.default);
  }
});